<section class="container-fluid">
<div class="container-div "
>
  <div
    class="row center"
  >

    <div
      class="card card-login text-center"
    >
      <div class="card-title">
        <img
          alt=""
          class="img-fluid"
          id="launch"
          src="assets/logo/sinfondo.png"
        />
      </div>
      <div class="card-body">
        <div class="col-12 pb-3">
          <span class="welcome">Bienvenido a</span>
        </div>
        <span class="zen ">PDG Light</span
        > 
        <div id="buttonDiv" class="mt-4 d-flex justify-content-center bd-highlight mb-2"></div> 
        <hr class="mt-4 mb-3" />
        <div class="row">
          <div class="col-12 created">
            <span class="color-white footer-font"
              >Creado&nbsp;con&nbsp;</span
            ><span id="hearth">❤️</span
            ><span class="color-white footer-font">
              por&nbsp;<a
                href="https://www.zentagroup.com/"
                style="color: #fff;"
                target="blank"
                >Zenta&nbsp;Group</a
              ></span
            >
          </div>
          <div class="col v">
            Zentown Desktop
          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>
</section>